if (!customElements.get('trust-badge')) {
  customElements.define(
    'trust-badge',
    class extends HTMLElement {
      constructor() {
        super();
        this.data = Debutify.widgets['dbtfy-trust-badge'];

        ({
          showHeading: this.showHeading,
          showSubheading: this.showSubheading,
          showInformativeText: this.showInformativeText,
          badgeAlignment: this.badgeAlignment,
          alignment: this.alignment,
          layout: this.layout,
        } = this.dataset);

        const templateScript = document.querySelector('#dbtfy-trust-badge');
        if (templateScript) {
          const templateHTML = templateScript.innerHTML;
          const templateElement = document.createElement('div');
          templateElement.innerHTML = templateHTML;
          this.template = templateElement;
        }

        this.init();
      }

      init() {
        if (!this.template) return;

        this.template = this.template.cloneNode(true);

        const blockData = this.template.querySelector('dbtfy-slider-component');
        if (!blockData) return;

        this.data.trust_badges_enable_card = blockData.dataset.enableCard == 'true';
        this.data.trust_badges_enable_gray_logos = blockData.dataset.enableGrayLogos == 'true';
        this.data.trust_badges_logo_heading_size = blockData.dataset.headingSize;
        this.data.trust_badges_logo_text_size = blockData.dataset.textSize;
        this.data.desktop_col_width = blockData.dataset.desktopCol;
        this.data.mobile_col_width = blockData.dataset.mobileCol;
        this.data.icon_block_type = blockData.dataset.iconBlockLayout;

        this.innerHTML = '';

        let badge_column_class = 'grid--12-col dbtfy-trust-badge-images--rows-items';
        if (this.data.icon_block_type != 'row') {
          badge_column_class = `grid--${this.data.desktop_col_width}-col-desktop grid--${this.data.desktop_col_width}-col-tablet grid--${this.data.mobile_col_width}-col`;
        } else {
          badge_column_class = `grid--1-col-desktop grid--1-col-tablet grid--1-col single-block`;
        }

        const dynamicStrings = {
          logo_heading_size: this.data.trust_badges_logo_heading_size,
          logo_text_size: this.data.trust_badges_logo_text_size,
          enable_card: this.data.trust_badges_enable_card ? 'card-background' : '',
          enable_gray_logos: this.data.trust_badges_enable_gray_logos ? 'dbtfy-trust-badge--enable-graylogo img' : '',
          badge_column_class: badge_column_class,
          trust_badges_alignment: this.alignment,
        };

        if (this.showInformativeText == 'false') this.template.querySelector('.information')?.remove();
        if (this.showHeading == 'false') this.template.querySelector('.heading')?.remove();
        if (this.showSubheading == 'false') this.template.querySelector('.subheading')?.remove();

        if (this.layout == 'payment_options') {
          // remove icon-block container
          this.template.querySelector('.other_option_block')?.remove();

          // replace the default dynamic icons with one static image
          const paymentIconRow = this.template.querySelector('.dbtfy-payment-icon-row');
          if (paymentIconRow) {
            paymentIconRow.innerHTML = `
              <img src="https://cdn.shopify.com/s/files/1/0903/4553/7878/files/payment_full-us_1_2_1.webp?v=1745096937"
                   alt="Accepted payment methods"
                   style="max-width:100%;height:auto;padding-top:10px;">
            `;
          }
        } else {
          // remove payment-options container when not needed
          this.template.querySelector('.payment_option_block')?.remove();
        }

        this.innerHTML = Debutify.replaceVariables(this.template.innerHTML, dynamicStrings);
      }
    }
  );
}
